import { makeStyles } from '@mui/styles';

import theme from 'src/style-system/theme';
import {
  BLOG_BG_IMAGE_URL_DESKTOP,
  BLOG_BG_IMAGE_URL_MOBILE,
} from '@utils/data';

export const useStyles = makeStyles({
  mainContainer: {
    position: 'relative',
    backgroundImage: `url(${BLOG_BG_IMAGE_URL_MOBILE})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.up(720)]: {
      backgroundImage: `url(${BLOG_BG_IMAGE_URL_DESKTOP})`,
    },
  },

  headerContainer: {
    background: 'linear-gradient(180deg, #1D1C1B 0%, rgba(29, 28, 27, 0) 100%)',
  },

  title: {
    padding: '40px 25px 60px',
    [theme.breakpoints.up('sm')]: {
      padding: '40px 25px 60px',
    },
  },
});
